<template>
  <v-dialog
    v-model="isOpenModale"
    fullscreen
    transition="slide-x-transition"
    @click:outside="onClose"
  >
    <v-card class="left-vertical-card">
      <div class="d-flex bg-titre">
        <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
          Filtrer mes apports
        </div>

        <v-btn
          class="align-self-center"
          text
          @click="onClose"
        >
          <v-icon color="secondary">
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <BaseErrorMessage
        v-if="erreur.updateFiltres"
        message="Erreur serveur. merci de réessayer plus tard."
      />
      <div v-if="!erreur.updateFiltres">
        <v-row
          class="mt-6"
          no-gutters
        >
          <v-col class="px-3">
            <AgrialSelect
              v-model="numeroBonApportSelected"
              :disabled="loading.updateFiltres"
              :items="filtresValeursPossibles.numerosBonsApport"
              label="N° du bon d’apport"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="px-3">
            <AgrialSelect
              v-model="typeContratApportSelected"
              :disabled="loading.updateFiltres"
              :items="filtresValeursPossibles.typesContratApport"
              label="Type de contrat"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="px-3">
            <AgrialSelect
              v-model="numeroContratApportSelected"
              :disabled="loading.updateFiltres"
              :items="filtresValeursPossibles.numerosContratsApport"
              label="N° de contrat"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="px-3">
            <AgrialSelect
              v-model="moisApportSelected"
              :disabled="loading.updateFiltres"
              :items="buildMoisApport"
              :item-text="item => item.libelleMois"
              label="Mois"
              return-object
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="px-3">
            <AgrialSelect
              v-model="graineValoriseeSelected"
              :disabled="loading.updateFiltres"
              :items="filtresValeursPossibles.grainesValorisees"
              :item-text="item => item.libelleGraineValorisee"
              label="Graine valorisée"
              return-object
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col
            class="px-2"
            cols="6"
          >
            <BaseButton
              :is-loading="loading.updateFiltres"
              libelle-btn="Annuler"
              @click="onAnnuler"
            />
          </v-col>
          <v-col
            class="px-2"
            cols="6"
          >
            <BaseButton
              :is-loading="loading.updateFiltres"
              is-color-branche
              libelle-btn="Valider"
              @click="onValider"
            />
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>

import AgrialSelect from '@/components/form/agrial-select.vue'
import {mapActions, mapGetters} from 'vuex'
import BaseButton from '@/components/common/base-button.vue'
import BaseErrorMessage from '@/components/common/base-error-message.vue'

export default {
  name: 'FiltreApportsModal',
  components: {BaseErrorMessage, BaseButton, AgrialSelect},
  props: {
    anneeRecolte: {
      type: String,
      default: null
    },
    codeGraineRs3: {
      type: String,
      default: null
    },
    isOpenModalFiltres: {
      type: Boolean,
      default:false
    }
  },

  data () {
    return {
      loading: {
        filtres: false,
        updateFiltres: false,
      },
      erreur: {
        filtres: false,
        updateFiltres: false,
      },
      isOpenModale: false,
      numeroBonApportSelected: null,
      typeContratApportSelected: null,
      numeroContratApportSelected: null,
      moisApportSelected: null,
      graineValoriseeSelected: null
    }
  },

  computed: {
    ...mapGetters({
      filtresAdherent: 'filtresApports/filtresAdherent',
      filtresValeursPossibles: 'filtresApports/filtresValeursPossibles'
    }),
    buildMoisApport () {
      const listeObjMoisApport = []
      Object.values(this.filtresValeursPossibles.moisApport).forEach((element) => {
        Object.entries(element).forEach(([k, v]) =>
          listeObjMoisApport.push({ codeMois : k, libelleMois: v})
          )
      })      
      return listeObjMoisApport
    }
  },

  created () {
    this.isOpenModale = this.isOpenModalFiltres
    this.resetAllSelects()   
  },

  methods: {
    ...mapActions({
      setFiltres: 'filtresApports/setFiltres'
    }),

    updateFiltresAdherent () {
      this.loading.updateFiltres = true
      this.erreur.updateFiltres = false
      const filtresAUpdate = {
        numerosBonsApport: this.numeroBonApportSelected,
        typesContratApport: this.typeContratApportSelected,
        numerosContratsApport: this.numeroContratApportSelected,
        moisApport: this.moisApportSelected.codeMois,
        grainesValorisees: this.graineValoriseeSelected
      }
      return this.setFiltres(filtresAUpdate)
        .then(() => this.resetAllSelects())
        .catch(() => this.erreur.updateFiltres = true)
        .finally(() => this.loading.updateFiltres = false)
    },

    resetAllSelects () {
      const mois = [
        'Tous',
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre'
      ]      
      this.numeroBonApportSelected = this.filtresAdherent.numerosBonsApport
      this.typeContratApportSelected = this.filtresAdherent.typesContratApport
      this.numeroContratApportSelected = this.filtresAdherent.numerosContratsApport ? this.filtresAdherent.numerosContratsApport : 'Tous'
      this.moisApportSelected = { codeMois: this.filtresAdherent.moisApport, libelleMois: this.filtresAdherent.moisApport !== 'Tous' ? mois[this.filtresAdherent.moisApport] : 'Tous' }
      this.graineValoriseeSelected = this.filtresAdherent.grainesValorisees
    },

    async onValider () {
      await this.updateFiltresAdherent()
      this.$emit('update', this.filtresAdherent)
    },

    onAnnuler () {
      this.resetAllSelects()
      this.$emit('close')
    },

    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
</style>
